import { TableColumn, TableOptions } from "..";

import { getDefaultSortBy, getDefaultSortOrder } from ".";

export function getDefaultOptions<TRecord>(
  columns: TableColumn<TRecord>[],
  options?: Partial<TableOptions<TRecord>>
): TableOptions<TRecord> {
  return {
    searchable: false,
    sortable: false,
    filterable: false,
    paginationable: false,
    exportable: false,
    selectable: false,
    rowClickable: true,
    showSelectAll: true,
    showRecordCount: true,
    initialSortBy: options && !options.sortable ? "" : getDefaultSortBy(columns),
    initialSortOrder: getDefaultSortOrder(columns),
    initialPageSize: 25,
    initialPage: 0,
    rowsPerPageOptions: [5, 10, 25],
    stickyHeader: true,
    searchPlaceholder: "Search...",
    exportFileName: "data",
    hideTableHead: false,
    tableStyle: {},
    headStyle: {},
    bodyStyle: {},
    titleStyle: {},
    emptyRowStyle: {},
    paginationStyle: {},
    getRowStyles: () => ({}),
    getColumnStyles: () => ({}),
    getCellStyles: () => ({}),
    minBodyHeight: "initial",
    maxBodyHeight: "initial",
    layout: "auto",
    size: "medium",
    simplebarStyle: {},
  };
}
